import clsx from 'clsx'
import React from 'react'

import { NavLinkClickProperties } from '@Analytics/ampli'
import { ImageV4 } from '@Components/Image'
import { Link } from '@Components/Link'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductItem.module.scss'

export const ProductItem = ({
  action,
  analytics,
  className,
  content,
  disabled,
  discount,
  id,
  imageUrl,
  price,
  showViewProduct = false,
  url,
}: {
  action?: React.ReactNode
  analytics?: NavLinkClickProperties
  className?: string
  content: string | React.ReactNode
  disabled?: boolean
  discount?: string
  id?: string
  imageUrl: string
  price?: string
  showViewProduct?: boolean
  url?: string
}) => {
  const { t } = useTranslation()

  const useLinkWrapper = url && !showViewProduct

  return (
    <div className={clsx(className, styles.productItem, { [styles.disabled]: disabled })} id={id}>
      {useLinkWrapper && (
        <Link analytics={analytics} className={styles.imageWrapper} href={url || ''}>
          <ImageV4 height={90} src={imageUrl} width={90} />
        </Link>
      )}
      {!useLinkWrapper && (
        <div className={styles.imageWrapper}>
          <ImageV4 height={90} src={imageUrl} width={90} />
        </div>
      )}

      <div className={styles.contentWrapper}>
        {useLinkWrapper && (
          <Link analytics={analytics} className={styles.content} href={url || ''}>
            {content}
          </Link>
        )}
        {!useLinkWrapper && (
          <div className={styles.content}>
            {content}
            {showViewProduct && (
              <Link analytics={analytics} className={styles.viewProduct} href={url || ''}>
                {t('common:VIEW_PRODUCT')}
              </Link>
            )}
          </div>
        )}

        <div className={styles.actions}>
          {price && (
            <span className={styles.prices}>
              {discount && <span className={styles.discount}>{discount}</span>}
              <span className={clsx(styles.price, discount && styles.discounted)}>{price}</span>
            </span>
          )}
          {action && (
            <div className={styles.action}>
              {action}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
